import { authenticatedSelector, getModifyFlag, getUiStatePhone, selectedPaymentMethodSelector } from 'selectors';
import { getBranchLocalAddenda } from 'selectors/skipTheCounterSelectors';
import { getOnlineCheckInProfileOciEligible, onlineCheckInProfileSelector } from 'selectors/checkinSelectors';
import {
  isCheckedInOrSkippingTheCounterSelector,
  isSkipTheCounterCompletedReservationSelector,
  hasSelectedPayAtCounter,
} from 'selectors/reservationFlowSelectors';
import { getAutoCommasSmsImplicitConsentEnabled } from 'selectors/appSelectors';
import actions from '@ehi/global-marketing-interface/lib/actions';
import utils from 'utils';
import { reservationProfileDetailsPath } from 'paths/reservationProfile';
import { gmiRequest } from 'actions/request';
import { mergePayload } from 'actions/reservation/mergePayload';
import WINDOW_OBJECT_KEYS from 'constants/windowObjectKeys';
import { i18n } from 'utils/i18n';

export const reviewCommit =
  ({ sourceCode } = {}) =>
  (dispatch, getState) => {
    const state = getState();
    const isTrueModify = getModifyFlag(state);
    const branchLocalAddenda = getBranchLocalAddenda(state);
    const phone = getUiStatePhone(state);
    const isProfileOciEligible = getOnlineCheckInProfileOciEligible(state);
    const isCheckedInOrSkippingTheCounter = isCheckedInOrSkippingTheCounterSelector(state);
    const isAuthUser = authenticatedSelector(state);
    const isSkippingTheCounter = isSkipTheCounterCompletedReservationSelector(state);
    const contactProfile = onlineCheckInProfileSelector(state);
    const showEuImpliedConsent = getAutoCommasSmsImplicitConsentEnabled(state);
    const payAtCounter = hasSelectedPayAtCounter(state);

    if (isTrueModify) {
      // if existing reservation has selectedPaymentMethod, have to pass payment_id to updated commit call
      const selectedPaymentMethod = selectedPaymentMethodSelector(state);
      if (selectedPaymentMethod) {
        dispatch(
          actions.reservations.commitState.set('payment_id', {
            payment_id: selectedPaymentMethod.payment_id,
          })
        );
      }
    }

    // if phone is masked in a non-modify commit, do not pass phone value with the commit call
    if (!isTrueModify && utils.fieldValidation.isMasked(phone)) {
      dispatch(actions.reservations.commitState.unset('phone'));
    }

    const data = {
      ...(!isTrueModify && showEuImpliedConsent && { is_auto_comms_consent_implied: true }),
      phone,
      phoneCountryCode: contactProfile?.contact_profile?.phones?.[0]?.country_code || utils.config.getDomainCountry(),
      isTrueModify,
      payAtCounter,
    };

    const opts = { source_code: sourceCode };
    const requestOpts = {};

    if (isTrueModify && isSkippingTheCounter && utils.safeToJS(branchLocalAddenda)) {
      opts.accept_branch_local_addenda = true;
    }
    // If the user has completed their profile, add the `online_check_in` flag to active OCI
    // (unless reservation already have OCI/STC activated)

    const hasProfileDetails = utils.safeToJS(state?.getIn(reservationProfileDetailsPath));

    if (isProfileOciEligible && !isCheckedInOrSkippingTheCounter) {
      opts.online_check_in = true;

      // If auth user tries to modify unauth user's reservation, `online_check_in` flag should not be added
      if (isTrueModify && isAuthUser && !hasProfileDetails) {
        delete opts.online_check_in;
      }

      // if this is not true modify and the user is authenticated and OCI eligible, also flag for auto_check_in
      if (!isTrueModify && isAuthUser) {
        opts.auto_check_in = true;
      }
    }

    return dispatch(
      gmiRequest({
        action: actions.reservations.commit(opts, data, requestOpts, mergePayload),
        loadingOverlay: true,
        loadingMessage: isTrueModify ? i18n('updating_reservation') : i18n('confirming_reservation'),
        onComplete: (response) => {
          if (!response.messages) {
            utils.localStorage.deleteReservationLocalStorage();
            //  We push the #start page to history so when we go back from the confirmation page
            //  it takes us straight  to the #start page
            window.history.pushState(null, null, utils.config.getRedirectUrl(WINDOW_OBJECT_KEYS.RESERVATION_INFLOW));
            utils.phoneInput.selectedCountryDetails.remove();
          }
          return response;
        },
      })
    );
  };
